import React from "react";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const img = "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&q=85";

const projects = [
  {
    tag: "PCTO",
    title: "Formazione Scuola Lavoro",
    text: "Percorsi PCTO (ex Alternanza Scuola Lavoro) su misura per istituti secondari: arti grafiche, editoria, tutela del patrimonio, ospitalità. Certificazioni finali e progetto documentato.",
    bullets: ["20-80 ore modulari","Tutor interno + tutor scolastico","Report finale e attestati","Alloggio incluso opzionale"],
  },
  {
    tag: "Erasmus+ VET",
    title: "Mobilità Erasmus VET",
    text: "Programmi di mobilità Erasmus+ VET di 2 o 3 settimane. Ospitiamo delegazioni europee di istituti VET tra artigianato, museo, botteghe e attività linguistico-culturali.",
    bullets: ["Alloggio in struttura","Programma settimanale strutturato","Visite ad Urbino e Marche","Europass a fine percorso"],
  },
  {
    tag: "Adulti",
    title: "Corsi per Adulti",
    text: "Weekend intensivi e settimane residenziali per adulti appassionati di stampa d'arte, calcografia, xilografia e legatoria. Piccoli gruppi, docenti maestri artigiani.",
    bullets: ["Weekend / week intensivi","Materiali inclusi","Docenti maestri artigiani","Cena tipica marchigiana"],
  },
];

export default function Progetti() {
  return (
    <Layout>
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-16 grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-7">
          <div className="overline">Progetti formativi</div>
          <h1 className="font-display text-5xl lg:text-7xl leading-[0.95] mt-3">
            Percorsi che lasciano il segno.
          </h1>
          <p className="mt-6 text-lg text-[#6B6960] leading-relaxed max-w-2xl">
            Progettiamo esperienze formative co-costruite con docenti, coordinatori Erasmus,
            enti di formazione e associazioni culturali.
          </p>
        </div>
        <div className="lg:col-span-5 aspect-[4/5] overflow-hidden">
          <img src={img} alt="Studenti in laboratorio" className="w-full h-full object-cover" />
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24 space-y-6">
        {projects.map((p, i) => (
          <div key={p.tag} className="grid grid-cols-1 lg:grid-cols-12 gap-8 border-t border-[#E2DFD6] pt-10">
            <div className="lg:col-span-4">
              <div className="overline">0{i + 1} · {p.tag}</div>
              <h2 className="font-display text-4xl mt-3">{p.title}</h2>
            </div>
            <div className="lg:col-span-5 text-[#6B6960] leading-relaxed">{p.text}</div>
            <ul className="lg:col-span-3 space-y-2 text-sm text-[#1A1A1A]">
              {p.bullets.map((b) => <li key={b}>· {b}</li>)}
            </ul>
          </div>
        ))}
        <div className="pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 border-t border-[#E2DFD6]">
          <h3 className="font-display text-3xl">Vuoi progettare un percorso con noi?</h3>
          <div className="flex gap-3">
            <Link to="/contatti"><Button variant="outline" className="rounded-full h-11 px-6 border-[#1A1A1A]/20">Contattaci</Button></Link>
            <Link to="/prenota"><Button className="btn-primary-cdm rounded-full h-11 px-6">Richiedi preventivo</Button></Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
